function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isBlank from "@sedan-utils/is-blank";
import { get } from "lodash";
import { ScreenItem, ViewBuilderCpWrapperUtil } from "./ViewBuilderCpWrapperUtil";
export var ViewBuilderData = /*#__PURE__*/_createClass(function ViewBuilderData() {
  _classCallCheck(this, ViewBuilderData);
  _defineProperty(this, "loadingHtml", void 0);
  _defineProperty(this, "isRequestStart", void 0);
  _defineProperty(this, "domList", void 0);
  _defineProperty(this, "originalText", void 0);
});
var Params = /*#__PURE__*/_createClass(function Params() {
  _classCallCheck(this, Params);
  _defineProperty(this, "id", "");
  _defineProperty(this, "textAreaValue", "");
  _defineProperty(this, "setNodes", function () {
    return undefined;
  });
  _defineProperty(this, "updateShareAppData", void 0);
  _defineProperty(this, "viewBuilderService", void 0);
  _defineProperty(this, "uploadService", void 0);
});
export var ViewBuilderWorker = /*#__PURE__*/function () {
  function ViewBuilderWorker(params) {
    _classCallCheck(this, ViewBuilderWorker);
    _defineProperty(this, "isStreaming", void 0);
    _defineProperty(this, "imgObj", {});
    _defineProperty(this, "domList", [new ScreenItem()]);
    this.params = params;
  }
  _createClass(ViewBuilderWorker, [{
    key: "getViewBuilderData",
    value: function getViewBuilderData() {
      var _this = this;
      var onReceived = function onReceived(msg) {
        var domList = ViewBuilderCpWrapperUtil.parseStrToObject("<screen>".concat(msg.fullText, "</screen>"));
        // 合并domlist
        _this.domList[0].screenInfo = _this.mergeDomList(domList, _this.domList);

        // 流式更新数据
        _this.updateNodeViewBuilderData();
        // 获取需要下载的图片数据
        var imgObj = _this.getNeedFetchImg();
        if (imgObj && !isBlank(imgObj)) {
          // 搜索图片
          _this.updateImgUrl({
            imgObj: imgObj
          });
        }
        if (msg.done) {
          var _domList$;
          // 方便测试查看数据
          console.log("view builder:", _this.domList, msg.fullText);
          _this.isStreaming = false;
          if (isBlank((_domList$ = domList[0]) === null || _domList$ === void 0 ? void 0 : _domList$.screenInfo)) {
            _this.domList = [];
            _this.updateNodeViewBuilderData();
            return;
          }
          _this.updateNodeViewBuilderData();
          // 搜索地址
          _this.updateMapData();
          _this.updateAudio();
        }
      };
      // 设置loading
      this.isStreaming = true;
      this.domList = [new ScreenItem()];
      this.updateNodeViewBuilderData();
      this.params.viewBuilderService.viewBuilder(this.params.textAreaValue).then(function (re) {
        return re.onReceived(onReceived);
      }).catch(function () {});
    }
  }, {
    key: "updateNodeViewBuilderData",
    value: function updateNodeViewBuilderData() {
      var _this2 = this,
        _this$params$updateSh,
        _this$params;
      this.params.setNodes(function (nodes) {
        return nodes.map(function (node) {
          if (node.id === _this2.params.id) {
            return _objectSpread(_objectSpread({}, node), {}, {
              data: _objectSpread(_objectSpread({}, node.data), {}, {
                viewBuilderData: {
                  loadingHtml: _this2.isStreaming,
                  isRequestStart: _this2.isStreaming,
                  domList: _this2.domList,
                  originalText: _this2.params.textAreaValue
                }
              })
            });
          }
          return node;
        });
      });
      (_this$params$updateSh = (_this$params = this.params).updateShareAppData) === null || _this$params$updateSh === void 0 || _this$params$updateSh.call(_this$params, {
        loadingHtml: this.isStreaming,
        isRequestStart: this.isStreaming,
        domList: this.domList,
        originalText: this.params.textAreaValue
      });
    }
  }, {
    key: "mergeDomList",
    value: function mergeDomList(newDomList, oldDomList) {
      var _newDomList$;
      return (((_newDomList$ = newDomList[0]) === null || _newDomList$ === void 0 ? void 0 : _newDomList$.screenInfo) || []).map(function (x, index) {
        if (!isBlank(oldDomList[0].screenInfo[index])) {
          var _oldDomList$0$screenI;
          return Object.assign({}, x, {
            imgKey: ((_oldDomList$0$screenI = oldDomList[0].screenInfo[index]) === null || _oldDomList$0$screenI === void 0 ? void 0 : _oldDomList$0$screenI.imgKey) || x.imgKey
          });
        }
        return x;
      });
    }
    // 从列表中加载图片直到可用的那条为止
  }, {
    key: "getAvailableImg",
    value: function getAvailableImg(imgUrls) {
      return new Promise(function (resolve) {
        var img = new Image();
        var idx = 0;
        img.onerror = function () {
          idx++;
          if (idx < imgUrls.length) {
            img.src = imgUrls[idx];
          }
        };
        img.onload = function () {
          resolve(img.src);
          img = null;
        };
        img.src = imgUrls[idx];
      });
    }
    // 获取需要去搜索的图片key
  }, {
    key: "getNeedFetchImg",
    value: function getNeedFetchImg() {
      var _this$domList$,
        _this3 = this;
      var list = ((_this$domList$ = this.domList[0]) === null || _this$domList$ === void 0 ? void 0 : _this$domList$.screenInfo) || [];
      if (isBlank(list)) return {};
      var imgObj = {};
      list.forEach(function (item, index) {
        var imgKey = item.imgKey;
        if (imgKey && isBlank(_this3.imgObj[imgKey]) && !imgKey.includes("http") && !Array.isArray(imgKey)) {
          imgObj[imgKey] = {
            index: index,
            type: item.type
          };
          _this3.imgObj[imgKey] = imgObj[imgKey];
        }
      });
      return imgObj;
    }
  }, {
    key: "updateImgUrl",
    value: function updateImgUrl(params) {
      var _this4 = this;
      Object.keys(params.imgObj).forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key) {
          var res, result, current, _result$data, imgUrls, imgUrl;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.params.viewBuilderService.imgSearch(key);
              case 2:
                res = _context.sent;
                if (res.data) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                result = res.data;
                current = params.imgObj[key];
                if (!(current.type === "c2")) {
                  _context.next = 11;
                  break;
                }
                // 轮播图
                _this4.domList[0].screenInfo[current.index].imgKey = (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.images_results ? result.data.images_results.slice(0, 3).map(function (im) {
                  return im === null || im === void 0 ? void 0 : im.original;
                }) : [];
                _context.next = 16;
                break;
              case 11:
                imgUrls = (result.data.images_results || []).map(function (x) {
                  return x.original;
                });
                _context.next = 14;
                return _this4.getAvailableImg(imgUrls);
              case 14:
                imgUrl = _context.sent;
                _this4.domList[0].screenInfo[current.index].imgKey = imgUrl;
              case 16:
                // 如果streaming完成后图片还没加载完成需要单独更新
                if (!_this4.isStreaming) {
                  _this4.updateNodeViewBuilderData();
                }
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleLocationFetch",
    value: function () {
      var _handleLocationFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
        var result, res, address, locationObj, latLng, current;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.params.viewBuilderService.getMapAddressGps(params.addr);
            case 2:
              result = _context2.sent;
              if (result.data) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              res = result.data;
              address = get(res, "results.[0].formatted_address", "");
              locationObj = get(res, "results.[0].geometry.location", {
                lng: 0,
                lat: 0
              });
              latLng = [locationObj.lng, locationObj.lat];
              current = params.mapObj[params.key];
              if (params.isStartAddr) {
                this.domList[0].screenInfo[current.index].mapData.startLocation.address = address;
                this.domList[0].screenInfo[current.index].mapData.startLocation.latlng = latLng;
              } else {
                this.domList[0].screenInfo[current.index].mapData.endLocation.address = address;
                this.domList[0].screenInfo[current.index].mapData.endLocation.latlng = latLng;
              }
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleLocationFetch(_x2) {
        return _handleLocationFetch.apply(this, arguments);
      }
      return handleLocationFetch;
    }()
  }, {
    key: "updateMapData",
    value: function updateMapData() {
      var _this$domList$2,
        _this5 = this;
      var list = ((_this$domList$2 = this.domList[0]) === null || _this$domList$2 === void 0 ? void 0 : _this$domList$2.screenInfo) || [];
      if (isBlank(list)) return;
      var mapObj = {};
      list.forEach(function (item, index) {
        if (item.type.includes("map") && item.mapData.mapKey) {
          mapObj[item.mapData.mapKey] = {
            index: index,
            type: item.type
          };
        }
      });
      Object.keys(mapObj).forEach( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(key) {
          var type, promiseArr, addrs;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                type = mapObj[key].type;
                promiseArr = [];
                if (type === "map1") {
                  promiseArr = [_this5.handleLocationFetch({
                    key: key,
                    addr: key,
                    mapObj: mapObj
                  })];
                } else {
                  addrs = key.split(";");
                  promiseArr = addrs.map( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(addr, index) {
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt("return", _this5.handleLocationFetch({
                              isStartAddr: index === 0,
                              key: key,
                              addr: addr,
                              mapObj: mapObj
                            }));
                          case 1:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3);
                    }));
                    return function (_x4, _x5) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }
                _context4.next = 5;
                return Promise.all(promiseArr);
              case 5:
                _this5.updateNodeViewBuilderData();
              case 6:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getAllScreenInfoWords",
    value: function getAllScreenInfoWords(list) {
      var words = "";
      list.forEach(function (item) {
        words += item.head;
        words += item.paragraph;
      });
      return words;
    }
  }, {
    key: "updateAudio",
    value: function updateAudio() {
      var _this$domList$3,
        _this6 = this;
      var list = ((_this$domList$3 = this.domList[0]) === null || _this$domList$3 === void 0 ? void 0 : _this$domList$3.screenInfo) || [];
      if (isBlank(list)) return;
      list.forEach( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item, index) {
          var words, result, blob, uploadRes;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!item.audio) {
                  _context5.next = 14;
                  break;
                }
                words = _this6.getAllScreenInfoWords(list);
                _context5.next = 4;
                return _this6.params.uploadService.tts(words);
              case 4:
                result = _context5.sent;
                if (!result.data) {
                  _context5.next = 14;
                  break;
                }
                _context5.next = 8;
                return result.data.data.blob();
              case 8:
                blob = _context5.sent;
                _context5.next = 11;
                return _this6.params.uploadService.upLoad({
                  blob: blob
                });
              case 11:
                uploadRes = _context5.sent;
                _this6.domList[0].screenInfo[index].audio = {
                  initCreateBlobUrl: uploadRes.initCreateBlobUrl,
                  textAreaValue: uploadRes.textAreaValue
                };
                _this6.updateNodeViewBuilderData();
              case 14:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x6, _x7) {
          return _ref4.apply(this, arguments);
        };
      }());
    }

    /**
     * 是否显示builder UI
     * @param enableViewBuildFeatureTag
     * @param showBuilder
     */
  }], [{
    key: "isShowBuilderUI",
    value: function isShowBuilderUI(showBuilderUI) {
      return showBuilderUI;
    }
  }]);
  return ViewBuilderWorker;
}();